import {h, Fragment} from "preact"
import { useActions, useAppState } from '@nosto/preact';
import { useState } from 'preact/hooks';

export default function ResaleButtons() {
    const { response: { products: { facets } } = {} } = useAppState();
    const { toggleProductFilter } = useActions();

    const resaleFacet = facets?.find(f => f.field === 'extra.resale');
    if (!resaleFacet) return null;

    const [selectedValue, setSelectedValue] = useState(null);

    const newFacetValue = resaleFacet.data.find(v => v.value === 'false');
    const resaleFacetValue = resaleFacet.data.find(v => v.value === 'true');

    const hasNewProducts = newFacetValue && newFacetValue.count > 0;
    const hasResaleProducts = resaleFacetValue && resaleFacetValue.count > 0;
    
    if (!hasNewProducts && !hasResaleProducts) return null;

    const handleClick = async (value) => {
        if (selectedValue === value) return;

        setSelectedValue(value);

        if (value === null) {
            if (newFacetValue?.selected) {
                await toggleProductFilter(resaleFacet.field, 'false', false);
            }
            if (resaleFacetValue?.selected) {
                await toggleProductFilter(resaleFacet.field, 'true', false);
            }
        } else {
            if (value === 'false' && resaleFacetValue?.selected) {
                await toggleProductFilter(resaleFacet.field, 'true', false);
            } else if (value === 'true' && newFacetValue?.selected) {
                await toggleProductFilter(resaleFacet.field, 'false', false);
            }
            
            const targetFacet = resaleFacet.data.find(v => v.value === value);
            if (targetFacet && !targetFacet.selected) {
                await toggleProductFilter(resaleFacet.field, value, true);
            }
        }
    };

    const buttonClasses = (isActive, isFirst = false) =>
    `${isFirst ? 'ns-pl-0' : 'ns-px-2'} py-1 border rounded ${
        isActive ? 'bg-purple-500 text-white ns-color-black' : 'bg-white text-black'
    }`;

    return (
        <div className="resale-filter-buttons flex gap-2 p-2 bg-purple-100 rounded">
            <button
                className={buttonClasses(selectedValue === null, true)}
                onClick={() => handleClick(null)}
            >
                All Results
            </button>
            {hasNewProducts && (
                <button
                    className={buttonClasses(selectedValue === 'false')}
                    onClick={() => handleClick('false')}
                >
                    Mainline Collection
                </button>
            )}
            {hasResaleProducts && (
                <button
                    className={buttonClasses(selectedValue === 'true')}
                    onClick={() => handleClick('true')}
                >
                    DVF Vintage
                </button>
            )}
        </div>
    );
}